import { render } from "./YqEmpty.vue?vue&type=template&id=25a056d6&scoped=true"
import script from "./YqEmpty.vue?vue&type=script&lang=js"
export * from "./YqEmpty.vue?vue&type=script&lang=js"

import "./YqEmpty.vue?vue&type=style&index=0&id=25a056d6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25a056d6"],['__file',"src/components/YqEmpty.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "25a056d6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('25a056d6', __exports__)) {
    api.reload('25a056d6', __exports__)
  }
  
  module.hot.accept("./YqEmpty.vue?vue&type=template&id=25a056d6&scoped=true", () => {
    api.rerender('25a056d6', render)
  })

}


export default __exports__